import { createStore } from 'ui.vue3.vuex';

// Модули
import refundStatement from "./modules/refundStatementStore";
import freeFormStatement from "./modules/freeFormStatementStore";
import technicalFailure from "./modules/technicalFailureStatementStore";
import claim from "./modules/claimStatementStore";

import modal from "./modules/modal";

import errorController from "./modules/errorController";

const store = new createStore({
    modules: {
        refundStatement,
        freeFormStatement,
        technicalFailure,
        claim,
        modal,
        errorController
    }
});

export default store;
